import { render, staticRenderFns } from "./regulation.vue?vue&type=template&id=c44998de&scoped=true"
import script from "./regulation.vue?vue&type=script&lang=js"
export * from "./regulation.vue?vue&type=script&lang=js"
import style0 from "./regulation.vue?vue&type=style&index=0&id=c44998de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44998de",
  null
  
)

export default component.exports